<template>
  <div>
    <div class="modal__show-btn" @click="showModal">
      modal (イメージのみ) (セカンダリーボタン) 表示
    </div>
    <ImageModalWithSecondary
      v-if="showableModal"
      :image-url="imageUrl"
      :primary-button-text="'変更する'"
      :secondary-button-text="'セカンダリーボタン'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="clickedPrimary"
      @clicked-secondary="clickedSecondary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import ImageModalWithSecondary from '../../components/molecules/modals/with_secondary/image-modal-with-secondary'
import imageUrl from '../../../../images/styleguide/default_giftcard.png'

export default {
  components: { ImageModalWithSecondary },
  data() {
    return {
      showableModal: false,
      imageUrl
    }
  },
  methods: {
    showModal() {
      this.showableModal = true
    },
    closeModal() {
      this.showableModal = false
    },
    clickedPrimary() {
      window.alert('clicked primary button!')
      this.closeModal()
    },
    clickedSecondary() {
      window.alert('clicked secondary button!')
      this.closeModal()
    }
  }
}
</script>
